export type IconName =
  | 'hand'
  | 'discover'
  | 'discover-solid'
  | 'live'
  | 'live-solid'
  | 'messages'
  | 'messages-solid'
  | 'wallet'
  | 'wallet-solid'
  | 'user'
  | 'user-solid'
  | 'search'
  | 'bell'
  | 'sun'
  | 'moon'
  | 'close'
  | 'back'
  | 'chevron-right'
  | 'settings'
  | 'gift'
  | 'coin'
  | 'gem'
  | 'mic'
  | 'mic-off'
  | 'volume'
  | 'volume-off'
  | 'video'
  | 'video-off'
  | 'pause'
  | 'phone'
  | 'phone-off'
  | 'heart'
  | 'heart-solid'
  | 'star'
  | 'star-solid'
  | 'send'
  | 'more'
  | 'shield'
  | 'shield-check'
  | 'logout'
  | 'flag'
  | 'ban'
  | 'check'
  | 'users'
  | 'trending'
  | 'card'
  | 'arrow-in'
  | 'arrow-out'
  | 'eye'
  | 'eye-off'
  | 'crown'
  | 'sparkle'
  | 'plus'
  | 'globe'
  | 'lock'
  | 'camera'
  | 'edit'
  | 'seat'
  | 'clock'
  | 'refresh';

interface IconDef {
  readonly body: string;
  readonly fill?: boolean;
}

const S = (body: string): IconDef => ({ body });
const F = (body: string): IconDef => ({ body, fill: true });

export const ICONS: Record<IconName, IconDef> = {
  discover: S(
    '<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2.1 4.9-4.9 2.1 2.1-4.9 4.9-2.1z"/>',
  ),
  'discover-solid': F(
    '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.4 6.2-2.3 5.4a1 1 0 0 1-.5.5l-5.4 2.3a.5.5 0 0 1-.66-.66l2.3-5.4a1 1 0 0 1 .5-.5l5.4-2.3a.5.5 0 0 1 .66.66Z"/><circle cx="12" cy="12" r="1.4" fill="var(--surface-page)"/>',
  ),
  live: S(
    '<circle cx="12" cy="12" r="2.5"/><path d="M7.8 7.8a6 6 0 0 0 0 8.4M16.2 16.2a6 6 0 0 0 0-8.4M4.9 4.9a10 10 0 0 0 0 14.2M19.1 19.1a10 10 0 0 0 0-14.2"/>',
  ),
  'live-solid': F(
    '<circle cx="12" cy="12" r="3"/><path d="M7.8 7.8a6 6 0 0 0 0 8.4M16.2 16.2a6 6 0 0 0 0-8.4M4.9 4.9a10 10 0 0 0 0 14.2M19.1 19.1a10 10 0 0 0 0-14.2" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>',
  ),
  messages: S(
    '<path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.38 8.38 0 0 1 21 11.5Z"/>',
  ),
  'messages-solid': F(
    '<path d="M12.5 2C6.7 2 2 6.2 2 11.5c0 1.6.4 3.1 1.2 4.4L2 21.3a.6.6 0 0 0 .75.73l5.5-1.65a11.4 11.4 0 0 0 4.25.82C18.3 21.2 23 17 23 11.7 23 6.3 18.3 2 12.5 2Z"/>',
  ),
  wallet: S(
    '<path d="M3 8a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v1"/><path d="M3 8v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H4a1 1 0 0 1-1-1Z"/><circle cx="17" cy="13" r="1.2" fill="currentColor" stroke="none"/>',
  ),
  'wallet-solid': F(
    '<path d="M18 6H5a2 2 0 0 0-2 2 3 3 0 0 1 3-3h11a1 1 0 0 1 0 1Zm3 4v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-1h14a2 2 0 0 1 2 2Zm-4 3a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"/>',
  ),
  user: S('<circle cx="12" cy="8" r="4"/><path d="M4 20a8 8 0 0 1 16 0"/>'),
  'user-solid': F('<circle cx="12" cy="7.5" r="4.5"/><path d="M12 13.5c-4.4 0-8 2.9-8 6.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1c0-3.6-3.6-6.5-8-6.5Z"/>'),
  search: S('<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>'),
  bell: S(
    '<path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/>',
  ),
  sun: S(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
  ),
  moon: S('<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"/>'),
  close: S('<path d="M18 6 6 18M6 6l12 12"/>'),
  back: S('<path d="m15 18-6-6 6-6"/>'),
  'chevron-right': S('<path d="m9 6 6 6-6 6"/>'),
  settings: S(
    '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-2.82 1.17V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 7 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15H4.5a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 11 4.6h-.1a2 2 0 0 1 4 0v.09A1.65 1.65 0 0 0 17 6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 11V11a2 2 0 0 1 0 4Z"/>',
  ),
  gift: S(
    '<path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8"/><path d="M2 8h20v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/><path d="M12 8v13"/><path d="M12 8H7.5a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8ZM12 8h4.5a2.5 2.5 0 0 0 0-5C13 3 12 8 12 8Z"/>',
  ),
  coin: F(
    '<defs><linearGradient id="coinG" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe08a"/><stop offset="1" stop-color="#f5a623"/></linearGradient></defs><circle cx="12" cy="12" r="9" fill="url(#coinG)"/><circle cx="12" cy="12" r="9" fill="none" stroke="rgba(120,72,10,.35)" stroke-width="1"/><path d="M12 7.5c-1.9 0-3 .9-3 2.2 0 1.3 1.2 1.8 3 2.3 1.3.3 1.5.6 1.5 1 0 .5-.5.8-1.5.8s-1.5-.3-1.6-.9H8.6c.1 1.2 1 2 2.4 2.2v1.1h1.8v-1.1c1.6-.2 2.6-1.1 2.6-2.4 0-1.4-1.1-2-3-2.4-1.2-.3-1.5-.5-1.5-.9 0-.4.4-.7 1.3-.7.9 0 1.3.3 1.4.8h1.7c-.1-1.1-.9-1.9-2.2-2.1V6.5h-1.8Z" fill="rgba(120,72,10,.7)" stroke="none"/>',
  ),
  gem: S('<path d="M6 3h12l3 6-9 12L3 9Z"/><path d="M3 9h18M9 3 6 9l6 12M15 3l3 6-6 12"/>'),
  hand: S(
    '<path d="M8 11V5.5a1.5 1.5 0 0 1 3 0V11m0-1.5V4a1.5 1.5 0 0 1 3 0v5.5m0-1a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-1a6 6 0 0 1-5.2-3l-1.6-2.8a1.5 1.5 0 0 1 2.4-1.8L8 15"/>',
  ),
  mic: S(
    '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/>',
  ),
  'mic-off': S(
    '<path d="m2 2 20 20"/><path d="M9 9v2a3 3 0 0 0 4.5 2.6M15 10.5V6a3 3 0 0 0-5.9-.7"/><path d="M5 11a7 7 0 0 0 10.6 6M19 11a7 7 0 0 1-.5 2.6M12 18v3"/>',
  ),
  volume: S(
    '<path d="M11 5 6.5 9H3v6h3.5L11 19z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/>',
  ),
  'volume-off': S(
    '<path d="M11 5 6.5 9H3v6h3.5L11 19z"/><path d="m16 9 5 6M21 9l-5 6"/>',
  ),
  video: S('<rect x="2" y="6" width="14" height="12" rx="2"/><path d="m16 10 6-3v10l-6-3z"/>'),
  'video-off': S(
    '<path d="m2 2 20 20"/><path d="M10 6h4a2 2 0 0 1 2 2v1.5l4-2.5v10M16 16v0a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2"/>',
  ),
  pause: S('<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>'),
  phone: S(
    '<path d="M21 16.5v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 3.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L7.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/>',
  ),
  'phone-off': S(
    '<path d="m2 2 20 20"/><path d="M5.4 9a16 16 0 0 0 1.7 2.9M10.7 14.3a16 16 0 0 0 3 2M21 16.5v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-6.6-1.9M8 3.7A2 2 0 0 0 6.1 2h-3A2 2 0 0 0 1.1 4.1a19.8 19.8 0 0 0 1 4.3"/>',
  ),
  heart: S(
    '<path d="M20.8 5.6a5.5 5.5 0 0 0-7.8 0l-1 1-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1 7.8 7.8 7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8Z"/>',
  ),
  'heart-solid': F(
    '<path d="M12 21.4 3.6 13a5.5 5.5 0 0 1 7.8-7.8l.6.6.6-.6A5.5 5.5 0 0 1 20.4 13Z"/>',
  ),
  star: S(
    '<path d="m12 3 2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.6l1-5.8L3.5 9.7l5.9-.9Z"/>',
  ),
  'star-solid': F(
    '<path d="m12 2.8 2.7 5.5 6 .9a1 1 0 0 1 .56 1.7l-4.35 4.24 1 6a1 1 0 0 1-1.45 1.05L12 19.35l-5.4 2.84a1 1 0 0 1-1.45-1.05l1-6-4.35-4.24A1 1 0 0 1 2.36 9.2l6-.9Z"/>',
  ),
  send: S('<path d="M22 2 11 13M22 2l-7 20-4-9-9-4z"/>'),
  more: S('<circle cx="5" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="19" cy="12" r="1.4"/>'),
  shield: S('<path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5Z"/>'),
  'shield-check': S('<path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5Z"/><path d="m9 12 2 2 4-4"/>'),
  logout: S('<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>'),
  flag: S('<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V4s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7"/>'),
  ban: S('<circle cx="12" cy="12" r="9"/><path d="m5.6 5.6 12.8 12.8"/>'),
  check: S('<path d="M20 6 9 17l-5-5"/>'),
  users: S(
    '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8"/>',
  ),
  trending: S('<path d="M22 7 13.5 15.5l-4-4L2 19M16 7h6v6"/>'),
  card: S('<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/>'),
  'arrow-in': S('<path d="M17 7 7 17M17 17H7V7"/>'),
  'arrow-out': S('<path d="M7 17 17 7M7 7h10v10"/>'),
  eye: S('<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>'),
  'eye-off': S('<path d="M9.9 4.24A9.1 9.1 0 0 1 12 4c6.5 0 10 7 10 7a13 13 0 0 1-2.16 2.94M6.6 6.6A13 13 0 0 0 2 11s3.5 7 10 7a9 9 0 0 0 3.4-.66M9.9 9.9a3 3 0 0 0 4.2 4.2M2 2l20 20"/>'),
  crown: S('<path d="m3 8 3.5 3L12 5l5.5 6L21 8l-1.5 11h-15Z"/>'),
  sparkle: S(
    '<path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9Z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8Z"/>',
  ),
  plus: S('<path d="M12 5v14M5 12h14"/>'),
  globe: S('<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18Z"/>'),
  lock: S('<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>'),
  camera: S(
    '<path d="M4 8a2 2 0 0 1 2-2h1.5l1-1.5h7L16 6H18a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/><circle cx="12" cy="12.5" r="3.2"/>',
  ),
  edit: S('<path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>'),
  seat: S('<path d="M6 20v-3h12v3M6 17V9a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v8M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>'),
  clock: S('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>'),
  refresh: S('<path d="M21 12a9 9 0 1 1-2.6-6.3M21 4v5h-5"/>'),
};
